<template>
  <div class="catl-Loader">
    <div v-for="row in ROWS" :key="row.id" class="catl-Loader_Row">
      <div class="catl-Cell">
        <SkeletonItem :size="XS" :width="row.name" />
      </div>

      <div class="catl-Cell">
        <SkeletonItem
          v-for="ch in row.channels"
          :key="`${row.id}-${ch.id}`"
          :size="SM"
          :width="ch.width"
        />
      </div>

      <div class="catl-Cell">
        <SkeletonItem :appearance="SKELETON_APPEARANCES.SQUARE" :size="SM" />
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  SKELETON_APPEARANCES,
  SKELETON_SIZES
} from '@/utils/components-configurations/skeleton-item'

import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

defineOptions({
  name: 'CheckinsAlertsTableLoader'
})

const { XS, SM } = SKELETON_SIZES

const ROWS = [
  {
    id: 0,
    name: '190px',
    channels: [
      {
        id: 0,
        width: '120px'
      },
      {
        id: 1,
        width: '160px'
      }
    ]
  },
  {
    id: 1,
    name: '130px',
    channels: [
      {
        id: 0,
        width: '69px'
      },
      {
        id: 1,
        width: '56px'
      },
      {
        id: 2,
        width: '94px'
      },
      {
        id: 3,
        width: '48px'
      },
      {
        id: 4,
        width: '24px'
      }
    ]
  },
  {
    id: 2,
    name: '90px',
    channels: [
      {
        id: 0,
        width: '200px'
      }
    ]
  },
  {
    id: 3,
    name: '220px',
    channels: [
      {
        id: 0,
        width: '140px'
      },
      {
        id: 1,
        width: '180px'
      }
    ]
  },
  {
    id: 4,
    name: '90px',
    channels: [
      {
        id: 0,
        width: '60px'
      },
      {
        id: 1,
        width: '80px'
      },
      {
        id: 2,
        width: '40px'
      }
    ]
  }
]
</script>

<style lang="scss" scoped>
.catl-Loader_Row {
  height: 45px;
  display: flex;
  align-items: center;
  padding: 0 var(--cat-content-right-padding) 0 var(--cat-content-left-padding);
  width: 100%;
}

.catl-Cell {
  display: flex;
  align-items: center;

  &:not(:first-child) {
    gap: 8px;
  }

  &:first-child {
    flex: 1 1 100%;
    gap: 8px;
  }

  &:nth-child(2) {
    flex: 1 0 440px;
  }

  &:last-child {
    flex: 1 1 24px;
  }
}
</style>
